module.exports = __webpack_public_path__ + "img/background.a754b8de.png";